import {
  createFamocoConfig,
  getFamocoConfig,
  syncFamocoFleets,
  updateFamocoConfig
} from '@/api/famoco';
import { IFamocoConfig, IFamocoConfigResponse, IFamocoFleet } from '@/models/famoco';
import { ActionContext } from 'vuex';

import { IState } from '..';

export interface IFamocoState {
  config: IFamocoConfig | null;
  fleets: IFamocoFleet[];
  loading: boolean;
  error: boolean;
  message: string;
}

const state: IFamocoState = {
  config: null,
  fleets: [],
  loading: false,
  error: false,
  message: ''
};

const getters = {
  getFamocoConfig: (state: IFamocoState) => state.config,
  getFamocoFleets: (state: IFamocoState) => state.fleets,
  getFamocoState: (state: IFamocoState) => state
};

const actions = {

  fetchFamocoConfig(context: ActionContext<IFamocoState, IState>) {
    context.commit('setFamocoLoading');
    getFamocoConfig()
      .then(response => {
        context.commit('setFamocoConfigResponse', response.data);
      })
      .catch(err => {
        context.commit('setFamocoError', err.response?.data?.detail || err.message);
      });
  },

  saveFamocoConfig(
    context: ActionContext<IFamocoState, IState>,
    payload: { api_token?: string; org_id: number; base_url: string }
  ) {
    context.commit('setFamocoLoading');
    const existing = context.state.config;
    const request = existing?.id
      ? updateFamocoConfig(existing.id, payload)
      : createFamocoConfig(payload as { api_token: string; org_id: number; base_url: string });

    request
      .then(response => {
        context.commit('setFamocoConfigSaved', response.data);
      })
      .catch(err => {
        context.commit('setFamocoError', err.response?.data?.detail || err.message);
      });
  },

  syncFamocoFleets(context: ActionContext<IFamocoState, IState>) {
    context.commit('setFamocoLoading');
    syncFamocoFleets()
      .then(response => {
        context.commit('setFamocoFleets', response.data);
      })
      .catch(err => {
        context.commit('setFamocoError', err.response?.data?.detail || err.message);
      });
  }

};

const mutations = {

  setFamocoLoading: (state: IFamocoState) => (
    (state.loading = true),
    (state.error = false),
    (state.message = '')
  ),

  setFamocoError: (state: IFamocoState, message: string) => (
    (state.loading = false),
    (state.error = true),
    (state.message = message)
  ),

  setFamocoConfigResponse: (state: IFamocoState, data: IFamocoConfigResponse) => (
    (state.loading = false),
    (state.error = false),
    (state.config = data.config),
    (state.fleets = data.fleets)
  ),

  setFamocoConfigSaved: (state: IFamocoState, config: IFamocoConfig) => (
    (state.loading = false),
    (state.error = false),
    (state.config = config)
  ),

  setFamocoFleets: (state: IFamocoState, fleets: IFamocoFleet[]) => (
    (state.loading = false),
    (state.error = false),
    (state.fleets = fleets)
  )

};

export default { state, getters, actions, mutations };
